module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TableView', {
    attrs: {
      "registerName": "Liberação",
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableData": _vm.tableData,
      "tableHead": _vm.tableHead,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "disableCheckAll": true,
      "filterBadge": _vm.filterBadge,
      "loadingTable": _vm.config.loading.table
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c608d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/empresa/liberacao/index.vue
// module id = 1437
// module chunks = 45